import React from 'react';
import { Button, Typography, Upload, UploadProps } from 'antd';

import { Attachment } from '../../components/Attachment';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import { AddIcon } from '../../components/TableWithDataUpdate';
import Icon from '../../icons/Icon';
import { getUploadCandidateFileProps } from '../../utils/uploadCandidateFileProps';
import { AttachmentType } from '../emails/Emails.type';

export type CandidateAttachementsDataProps = {
  attachments: AttachmentType[];
  handleAttachmentDragging?: (id: string) => void;
  handleAttachmentUpload?: (fileId: string) => void;
  pickMode?: boolean;
  closePickMode?: () => void;
  onPick?: (fileId: string) => void;
  onSavePick?: () => void;
  chosenAttachement?: string;
};

export const CandidateAttachements: React.FC<CandidateAttachementsDataProps> = ({
  attachments,
  handleAttachmentDragging,
  handleAttachmentUpload,
  pickMode = false,
  closePickMode,
  onPick,
  onSavePick,
  chosenAttachement,
}) => {
  const uploadProps: UploadProps = {
    ...getUploadCandidateFileProps(),
    showUploadList: false,
    onChange: (info) => {
      if (info.file.status === 'done') {
        handleAttachmentUpload?.(info.file.response.uuid);
      }
    },
  };

  return (
    <StyledColumn padding="15px">
      <StyledRow justifyContent="space-between" gap="0">
        <StyledRow gap="0" justifyContent="flex-start" style={{ alignItems: 'center' }}>
          <Icon name="Attachment" />
          <Typography.Text style={{ paddingLeft: '15px', fontSize: '16px', fontWeight: '600' }}>
            Attachements
          </Typography.Text>
        </StyledRow>
        <Upload {...uploadProps}>
          <Button icon={<AddIcon />}>
            Add
          </Button>
        </Upload>
      </StyledRow>

      <StyledRow flexWrap="wrap" justifyContent="flex-start" gap="35px" padding="0 15px">
        {attachments.map((attachment) => (
          <Attachment
            key={attachment.fileId}
            setCvAttachement={handleAttachmentDragging}
            attachment={attachment}
            pickMode={pickMode}
            onPick={onPick}
            isChosen={chosenAttachement === attachment.fileId}
          />
        ))}
      </StyledRow>
      {pickMode && (
        <StyledRow justifyContent="flex-end">
          <Button onClick={closePickMode}>Cancel</Button>
          <Button onClick={onSavePick} type="primary">
            Set as CV
          </Button>
        </StyledRow>
      )}
    </StyledColumn>
  );
};
